// extracted by mini-css-extract-plugin
export default {"pop-up-wrapper":"PopUp_pop-up-wrapper__Kuzu3","display":"PopUp_display__xz-V1"};